module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/bottom-img.008555c1.png";